import { ReactComponent as CircleWarning } from 'assets/icons/circle_warning_fill.svg';
import { ReactComponent as SmallCloseIcon } from 'assets/icons/close_small.svg';
import toaster from 'toasted-notes';
import { ErrorHandlerProps } from './ErrorHandler.props';
import './style.scss';

const ErrorHandler = (({ error, className, hasCancel }: ErrorHandlerProps) => {

    toaster.notify(
        ({ onClose }) => (
            <>
                <div className={`error-notification ${className}`}>
                    <CircleWarning className="warning-icon" />
                    <span className="error-message">
                        {error.response ? error.response?.data?.message : (error || ' ')}
                    </span>
                    {hasCancel ? (
                        <button className="close-btn" onClick={onClose}>
                            بستن
                        </button>
                    ) : (
                        <SmallCloseIcon className="close-icon" onClick={onClose} />
                    )}
                </div>
            </>
        ),
        {
            position: 'top',
            duration: hasCancel ? null : 6000,
        }
    );

});

export default ErrorHandler;
